var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h4',{staticStyle:{"text-align":"center","margin":"20px"}},[_vm._v(_vm._s(this.$t('thankYouForPurchase')))])
}
var staticRenderFns = []

export { render, staticRenderFns }